import classnames from "classnames";
import React, { useCallback } from "react";
import styles from "./TextLink.module.scss";
import { useStableNavigate } from "./useStableNavigate";

interface TextLinkProps {
    /** Куда ведёт ссылка; null — нет прав на цель, рисуется простой текст */
    to: string | null;
    className?: string;
    children?: React.ReactNode;
}

/**
 * Текст-ссылка внутри таблиц и графиков: ФИО, номер проекта, раздел.
 *
 * Обычный клик ЛКМ переходит внутри приложения, без перезагрузки. Это настоящий `<a href>`,
 * поэтому Ctrl/⌘ + клик и средняя кнопка открывают новую вкладку силами браузера.
 * Клик не всплывает: строки, в которых стоит ссылка, по клику сворачиваются, а переход
 * их трогать не должен. При наведении — указатель и подчёркивание: видно, что можно перейти.
 */
export const TextLink: React.FC<TextLinkProps> = ({ to, className, children }) => {
    const navigate = useStableNavigate();

    const onClick = useCallback(
        (event: React.MouseEvent<HTMLAnchorElement>) => {
            event.stopPropagation();

            // новую вкладку открывает сам браузер — не мешаем
            if (!to || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
                return;
            }

            event.preventDefault();
            navigate(to);
        },
        [to, navigate]
    );

    if (!to) {
        return <span className={className}>{children}</span>;
    }

    return (
        <a href={to} className={classnames(styles.link, className)} onClick={onClick}>
            {children}
        </a>
    );
};
